import React from 'react'
import s from './ChooseServices.module.scss'
import { ReactComponent as UnckeckedIcon } from 'images/new-icons/unchecked.svg'
import { ReactComponent as CheckedIcon } from 'images/new-icons/checked.svg'
import { useTranslation } from 'react-i18next'

const ServicesCard = ({ title, duration, price, isSelected }) => {

    const {t} = useTranslation() as any;

    return (
        <div className={s.card}>
            <div className={s.card_left}>
                <div className={s.card_left_title}>{title}</div>
                <div className={s.card_left_inf}>{duration} {t('min')}</div>
            </div>
            <div className={s.card_price}>﷼{price}</div>
            <div className={s.card_checkbox}>{isSelected ? <CheckedIcon /> : <UnckeckedIcon />}</div>
        </div>
    )
}

export default ServicesCard
